// extracted by mini-css-extract-plugin
module.exports = {"outcome":"Outcomes_outcome__3JVbc","outcomeContent":"Outcomes_outcomeContent__3cpsE","outcomeName":"Outcomes_outcomeName__1LEXr","selected":"Outcomes_selected__2V7Xk"};